import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API_BASE_URL,
  LoginWithEmailOTP,
  verifyEmailOTP,
} from "../../Store/apiStore";
import CustomCheckout from "./Checkout";
import styles from "./checkout.module.css";
import axios from "axios";
import useUser from "../../Store/Context/UserContext";
import decodeToken from "../../lib/decodeToken";
import Loader2 from "../Loader2/Loader2";
export default function SubscriptionFlow() {
  const location = useLocation();
  // console.log("location",location)
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  // const priceId = location.state?.priceId;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const priceId = location.state?.priceId || sessionStorage.getItem("priceId") ;
  // console.log("priceId",priceId)
  const agentId = location.state?.agentId || sessionStorage.getItem("agentId");
  const price = location.state?.price ||  sessionStorage.getItem("price");
  const subscriptionId = location.state?.subscriptionId || sessionStorage.getItem("subscriptionId")
  const locationPath = location.state?.locationPath1 || null;
  const [paymentConfirmed,setPaymentConfirmed]=useState(false)
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [userVerified, setUserVerified] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [userId, setUserId] = useState("");

  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  let token = localStorage.getItem("token");
  const [userDetails, setUserDetails] = useState();

  useEffect(() => {
    if (!token) return;
    const result = decodeToken(token);
    setUserDetails(result);
    setUserId(result.id);
    setCustomerId(result.customerId)
    if (result?.email) setEmail(result.email);
    // console.log(result)
  }, []);

  useEffect(() => {
    if (subscriptionSuccess) {
       if(locationPath !== "/update"){
        navigate("/steps" , {state:{
          locationPath : "/checkout"

        }});
       }
       else{
         navigate("/fast-agent-detail");

       }


    }
  }, [subscriptionSuccess, navigate]);

  // Check subscription after OTP verified
  useEffect(() => {
    if (!customerId) return;

    const checkSubscription = async () => {
      try {
        const res = await fetch(`${API_BASE}/subscription/${customerId}` , {
           headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
        });
        const data = await res.json();

        const isActive =
          (data?.status === "active" || data?.status === "trialing") &&
          data?.price.id === priceId;

        setHasActiveSubscription(isActive);
      } catch (err) {
        console.error("❌ Subscription check failed:", err);
      } finally {
      }
    };

    checkSubscription();
  }, [ customerId, priceId]);



  const handleEditEmail = () => {
    // Reset flow
    setOtpSent(false);
    setOtp("");
    setOtpVerified(false);
    setCustomerId("");
    setUserId("");
    setMessage("");
  };
  const handleUpdateUserProfile = async (userId) => {
    console.log(userId, name, phone);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/endusers/users/${userId}`,
        {
          name: name.trim(),
          phone,
        }
      );
      console.log(response);
      if (response.status === 200) {
        setUser({
          name: response.data.user?.name,
        });
        sessionStorage.setItem(
          "OwnerDetails",
          JSON.stringify({ name: name.trim(), phone })
        );
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentConfirm = () => {
    setPaymentConfirmed(true);
    // console.log("Payment was confirmed");
  };
  // Render
  return (
    <div className={styles.container}>


      {/* Email Input with Edit button */}
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          margin: "20px 0 0 0",
        }}
      >
       
      </div>
      {otpSent ? "" : <div></div>}

     

      {/* Message */}
      {message && <p className={styles.message}>{message}</p>}

      {/* Subscription check loading */}

      {/* Already subscribed */}

      <div style={{ marginTop: "2rem" }}>
        <CustomCheckout
          email={email}
          customerId={customerId}
          priceId={priceId}
          userId={userId}
          price={price}
          onSubscriptionSuccess={() => {
            setSubscriptionSuccess(true);
          }}
          disabled={!otpVerified} // Submit button disabled until OTP verified
          agentId={agentId}
          locationPath={locationPath}
          subscriptionId={subscriptionId}
          onPaymentConfrim={handlePaymentConfirm}
        />
      </div>
    </div>
  );
}
